import { render, staticRenderFns } from "./inventaire.html?vue&type=template&id=ff2606a2&scoped=true&external"
import script from "./inventaire.js?vue&type=script&lang=js&external"
export * from "./inventaire.js?vue&type=script&lang=js&external"
import style0 from "./inventaire.scss?vue&type=style&index=0&id=ff2606a2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2606a2",
  null
  
)

export default component.exports